<template>
  <div
    class="py-2 py-lg-12 subheader subheader-transparent"
    v-bind:class="subheaderClasses"
    id="kt_subheader"
  >
    <notifications group="subheader" position="top center" />
    <loading
      :active.sync="loading"
      :can-cancel="false"
      color="#2196f3"
      :z-index="9"
      :is-full-page="fullPage"
    ></loading>
    <div
      class="d-flex flex-wrap flex-sm-nowrap justify-content-between align-items-center"
      v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }"
    >
      <div class="d-flex flex-wrap align-items-center mr-2">
        <!--begin::Heading-->
        <div class="d-flex flex-column">
          <!--begin::Title-->
          <h2 class="my-2 mr-5 font-weight-bold text-white">
            {{ title }}
          </h2>

          <BreadCrumbs :crumbs="breadcrumbs" />
        </div>
      </div>
      <div class="d-flex align-items-center">
        <div
          class="position-relative mr-5"
          v-if="currentUser.role === 'SuperAdmin'"
        >
          <span class="custom-input-label">
            <i class="mr-2 text-primary fa fa-file-import"></i>
            Import All
          </span>
          <b-form-file
            v-model="file"
            accept=".json"
            @input="readFile"
            class="btn btn-white"
          ></b-form-file>
        </div>

        <button
          class="p-3 btn btn-white"
          @click="downloadBackupALL"
          v-if="currentUser.role === 'SuperAdmin'"
        >
          <i class="text-primary fa fa-cloud-download-alt"></i>
          Export All
        </button>

        <!--begin::Button-->
        <!-- <a
          href="#"
          class="mr-2 px-6 py-3 font-weight-bold btn btn-transparent-white"
        >
          Reports
        </a> -->
        <!--end::Button-->
        <!--begin::Dropdown-->
        <!-- <b-dropdown
          size="sm"
          variant="link"
          toggle-class="custom-v-dropdown btn btn-white font-weight-bold py-3 px-6"
          no-caret
          right
          no-flip
          text="Actions"
          v-b-tooltip.hover="'Quick actions'"
        >
          <div class="min-w-md-250px navi navi-hover">
            <b-dropdown-text tag="div" class="navi-item">
              <a href="#" class="navi-link">
                <span class="navi-icon">
                  <i class="flaticon2-drop"></i>
                </span>
                <span class="navi-text">New Group</span>
              </a>
            </b-dropdown-text>
            <b-dropdown-text tag="div" class="navi-item">
              <a href="#" class="navi-link">
                <span class="navi-icon">
                  <i class="flaticon2-list-3"></i>
                </span>
                <span class="navi-text">Contacts</span>
              </a>
            </b-dropdown-text>
            <b-dropdown-text tag="div" class="navi-item">
              <a href="#" class="navi-link">
                <span class="navi-icon">
                  <i class="flaticon2-rocket-1"></i>
                </span>
                <span class="navi-text">Groups</span>
                <span class="navi-link-badge">
                  <span
                    class="label-inline font-weight-bold label label-light-primary"
                    >new</span
                  >
                </span>
              </a>
            </b-dropdown-text>
            <b-dropdown-text tag="div" class="navi-item">
              <a href="#" class="navi-link">
                <span class="navi-icon">
                  <i class="flaticon2-bell-2"></i>
                </span>
                <span class="navi-text">Calls</span>
              </a>
            </b-dropdown-text>
            <b-dropdown-text tag="div" class="navi-item">
              <a href="#" class="navi-link">
                <span class="navi-icon">
                  <i class="flaticon2-gear"></i>
                </span>
                <span class="navi-text">Settings</span>
              </a>
            </b-dropdown-text>
            <b-dropdown-text
              tag="div"
              class="my-3 navi-separator"
            ></b-dropdown-text>
            <b-dropdown-text tag="div" class="navi-item">
              <a href="#" class="navi-link">
                <span class="navi-icon">
                  <i class="flaticon2-magnifier-tool"></i>
                </span>
                <span class="navi-text">Help</span>
              </a>
            </b-dropdown-text>
            <b-dropdown-text tag="div" class="navi-item">
              <a href="#" class="navi-link">
                <span class="navi-icon">
                  <i class="flaticon2-bell-2"></i>
                </span>
                <span class="navi-text">Privacy</span>
                <span class="navi-link-badge">
                  <span
                    class="label-rounded font-weight-bold label label-light-danger"
                    >5</span
                  >
                </span>
              </a>
            </b-dropdown-text>
          </div>
        </b-dropdown> -->
        <!--end::Dropdown-->
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.custom-v-dropdown {
  &.dropdown-toggle {
    padding: 0;
    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }

  &.dropdown-menu {
    margin: 0;
    .b-dropdown-text {
      padding: 0;
    }
  }
}
.custom-file-input ~ .custom-file-label[data-browse]::after {
  content: "" !important;
  display: none;
}
.custom-input-label {
  position: absolute;
  z-index: 0;
  color: #3f4254;
  width: 104px;
  display: flex;
  cursor: pointer;
  background-color: #fff !important;
  border-color: #fff !important;
  height: 103%;
  border-radius: 7px;
  align-items: center;
  justify-content: center;
}
.custom-file {
  width: 95px;
  opacity: 0;
  cursor: pointer;
  .custom-file-label {
    background-color: #fff !important;
    border-color: #fff !important;
    .form-file-text {
      opacity: 0;
      cursor: pointer;
      pointer-events: all !important;
    }
  }
}
</style>

<script>
import { mapGetters } from "vuex";
import http from "@/axios";
import FileSaver from "file-saver";
import BreadCrumbs from "@/components/BreadCrumbs.vue";
export default {
  components: { BreadCrumbs },
  name: "KTSubheader",
  props: {
    breadcrumbs: Array,
    title: String,
  },
  data() {
    return {
      loading: false,
      fullPage: true,
      file: null,
      importedJSON: "",
    };
  },
  methods: {
    readFile(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.importedJSON = e.target.result;
        this.uploadFile();
        let json = JSON.parse(e.target.result);
      };
      reader.readAsText(file);
    },
    async uploadFile() {
      this.loading = true;
      await http
        .post("/sbc/ips/rules/import", { data: JSON.parse(this.importedJSON) })
        .then((res) => {
          this.$notify({
            group: "subheader",
            title: res.data.message,
            type: "success",
          });
          this.importedJSON = "";
          this.file = null;
          this.loading = false;
        })
        .catch((err) => {
          if (err && err.response) {
            this.$notify({
              group: "subheader",
              title: err.response.data.message,
              type: "error",
            });
          } else {
            this.$notify({
              group: "subheader",
              title: "Something went wrong!",
              type: "error",
            });
          }
          this.file = null;
          this.importedJSON = "";
          this.loading = false;
        });
    },
    async downloadBackupALL() {
      this.loading = true;
      await http
        .get(`/sbc/ips/rules/export`)
        .then((res) => {
          this.loading = false;
          let response = res.data.data;
          var blob = new Blob([JSON.stringify(response, null, "\t")], {
            type: "application/json;charset=utf-8",
          });
          FileSaver.saveAs(
            blob,
            "all-rules" + new Date().getSeconds() + ".json"
          );

          this.$notify({
            group: "subheader",
            title: res.data.message,
            type: "success",
          });
        })
        .catch((err) => {
          this.$notify({
            group: "subheader",
            title: "Something went wrong!",
            type: "error",
          });
          this.loading = false;
        });
    },
    importALL() {},
  },
  computed: {
    ...mapGetters(["layoutConfig", "currentUser"]),

    /**
     * Check if subheader width is fluid
     */
    widthFluid() {
      return this.layoutConfig("subheader.width") === "fluid";
    },

    subheaderClasses() {
      const classes = [];
      const style = this.layoutConfig("subheader.style");
      if (style) {
        classes.push(style);

        if (style === "solid") {
          classes.push("bg-white");
        }

        if (this.layoutConfig("subheader.fixed")) {
          classes.push("border-top");
        }
      }
      return classes.join(" ");
    },
  },
};
</script>
